<template>
  <div>
    <div class="detail-box ">
        <div class="bg">
          <div class="detail-info clearfiex">
            <!--详情-->
            <div class="det">
              <h2>预约信息</h2>
              <ul>
                <li>
                  <span>订单编号：</span>
                  <b>{{record.orderNo}}</b>
                </li>

                <li>
                  <span>场馆名称：</span>
                  <b>{{record.groundName}}</b>
                </li>

                <li>
                  <span>场地类型：</span>
                  <b><em>{{ record.sportType }}</em></b>
                </li>

                <li>
                  <span>预约手机：</span>
                  <b>{{ record.mobileNum }}</b>
                </li>

                <li>
                  <span>日期：</span>
                  <b>{{ record.addTime }}</b>
                </li>

                <li>
                  <span>金额：</span>
                  <b><i>￥{{record.totalAmount}}</i></b>
                </li>

                <li>
                  <span>是否包场：</span>
                  <b>{{ record.isEnclosure === '1' ? '是':'否' }}</b>
                </li>

                <li>
                  <span>场次：</span>
                  <div class="ci">
                    <b v-for="(item,index) in record.orderDetailVos" :key="index">{{ record.groundName}}
                      {{item.timeSlot}}</b>
                  </div>
                </li>

                <li>
                  <span>核销码：</span>
                  <b class="strong" style="display:flex; justify-content: center; flex-direction: column; align-items: center; text-align: center">
                    <div id="qrcode" style="margin-bottom: 5px"></div>
                    <b class="strong">{{ record.exchangeCode }}</b>
                  </b>
                </li>

                <li v-if="['1', '2', '3'].includes(record.status) && record.payType === '2'">
                  <span>校内转账结算单：</span>
                  <button @click="downInventory()" style="background:#2C68E4; border: none; color: #ffffff; border-radius: 100px; padding:8px 14px; font-size:12px">下载</button>
                </li>
                <li v-if="['1', '2', '3'].includes(record.status) && record.payType === '2' && record.inventoryUrl">
                  <span>预约报销链接：</span>
                  <button @click="jump(record.inventoryUrl)" style="background:#2C68E4; border: none; color: #ffffff; border-radius: 100px; padding:8px 14px; font-size:12px">跳转</button>
                </li>

              </ul>
            </div>

            <!--服务信息-->
            <div class="det" v-if="record.serviceVos && record.serviceVos.length > 0 ">
              <h2>服务信息</h2>
              <ul>
                <li>
                  <span>服务明细：</span>
                  <div class="ci">
                    <div class="mxi" v-for="(item,index) in record.serviceVos" :key="index">
                      <h3>{{item.serviceName}} X {{item.num}}</h3>
                      <h4>单价：<strong>{{item.price}}元</strong></h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="height: 150px"></div>
        <div class="fiex-box">
        <!-- 合计 -->
        <div class="heji">
          <span>服务合计：{{record.serviceMoney}}元</span>
          <span>订单总金额：{{record.amount}}</span>
          <span>会员优惠：<em>{{record.totalAmount - record.amount}}</em></span>
          <span>订单状态：<em>{{getDictName(orderStatusOptions, record.status)}}</em></span>
        </div>
        <!-- 计算 -->
        <div class="pay">
          <span>订单实际金额: ￥<b>{{record.totalAmount}}</b></span>
          <button v-if="record.status === '1'" @click="handleHx()">立即核销</button>
        </div>
        </div>

      </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {downInventory, writeOff, getByExchangeCode} from '@/api/order/order'
  import {Dialog} from "vant";

  export default {
    name: 'OrderHx',
    components: {
    },
    data() {
      return {
        qrcode: '',
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        record: {},
        sportTypeList: [],
        orderStatusOptions: [],
        getDictName,
        loading: false,
      }
    },
    created() {
      this.getDict()
    },
    mounted() {
      this.getDetail()
    },
    methods: {
      jump(url) {
        if (url) {
          window.location.href = url
        }
      },
      getDetail() {
        this.record = this.$route.params.order
        if (!this.record || !this.record.id) {
          this.$router.replace({name:'orderHxScan'})
        }

        // 生成二维码
        document.getElementById('qrcode').innerHTML = ''
        new QRCode("qrcode", {
          text: this.record.exchangeCode,
          width: 70,
          height: 70,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      },
      // 凭证下载
      downInventory() {
        downInventory(this.record.id).then(res => {
          if (res.code === 10000) {
            this.$toast("下载成功")
          }
        })
      },
      getDict() {
        getDictByType('sport_type').then(res => {
          if (res.result) {
            this.sportTypeList = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        })
        getDictByType('order_status').then(res => {
          if (res.result) {
            this.orderStatusOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        })
      },
      handleHx() {
        Dialog.confirm({
          message: '确认核销？',
        }).then(() => {
          writeOff({id: this.record.id, exchangeCode: this.record.exchangeCode}).then(res => {
            if (res.code === 10000) {
              this.getByExchangeCode(this.record.exchangeCode)
            }
            this.$toast(res.msg)
          })
        }).catch(() => {
        });
      },
      // 查询核销码对应的订单详情
      getByExchangeCode(code) {
        getByExchangeCode(code).then(res => {
          if (res.code === 10000) {
            if (res.result) {
              this.record = res.result
            } else {
              this.$toast('未查询到订单')
            }
          }
        })
      },
    }
  }
</script>

<style scoped>
  >>> .van-count-down {
    color: #FFFFFF;
    font-size: 18px;
    padding-left: 5px;
  }
  .fiex-box{
    position: fixed;
    width:100%;
    bottom:0;
    left: 0;
    padding: 0 5%;
  }
  .pay {
    display: flex;
    height: 48px;
    background: #9DAFD3;
    border-radius: 3px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .pay button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 168px;
    height: 48px;
    background: #2C68E4;
    border-radius: 3px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .pay span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0 10px;
  }

  .pay span b {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .heji {
    display: flex;
    flex-direction: column;
    padding: 10px 0;
  }

  .heji span {
    display: flex;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 5px 0;
  }

  .heji span em {
    color: #ff0000;
  }

  .detail-box {
    padding: 10px;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    background: #ffffff;
  }

  .detail-info {
    padding: 0 15px;
    background: url("../../../assets/l-top.png") top center no-repeat #EEF3F8;
    background-size: 100% 9px;
    position: relative;
    padding-bottom: 20px;
  }

  .detail-info::after {
    position: absolute;
    width: 100%;
    height: 9px;
    bottom: 0px;
    background: url("../../../assets/l-bottom.png") top center no-repeat;
    background-size: 100% 9px;
    left: 0;
  }

  .detail-info h2 {
    display: flex;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    padding: 25px 0 10px 0;
  }

  .det ul li {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #dedede;
    align-items: flex-start;
    justify-content: space-between;
    align-items: center;
  }
  .det ul li:last-child{
    border-bottom: none;
  }
  .det ul li span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #777777;
  }

  .det ul li b {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .det ul li em {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    background: #DEE3F9;
    border-radius: 18px;
    font-size: 11px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    padding: 0 5px;
    margin-left: 3px;
  }

  .det ul li i {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FF6600;
  }

  .ci {
    display: flex;
    flex-direction: column;
  }

  .ci b {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 10px;
  }

  .det ul li b.strong {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  .mxi {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .mxi h3 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .mxi h4 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .mxi h4 strong {
    color: #FF6600;
  }
</style>
